import { z } from 'zod'
import * as http from '@/util/http'

export const OccupationSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  emoji: z.string().optional(),
})

export type Occupation = z.infer<typeof OccupationSchema>

export async function fetchProfileOccupations(): Promise<Occupation[]> {
  const { data } = await http.get<Occupation[]>('/api/v1/user/profile/occupation')
  return data
}
